import examples from '../data/article-examples';
import { ENDPOINTS } from './ChatApiConstants';

const DEBUG = true;

export const localFetch = async ({ endpoint, fetchUrl, fetchParameters }) => {
    if (DEBUG) console.log(`localChatFetch :: ${fetchParameters.method} :: ${fetchUrl}`);

    switch (endpoint) {
        case ENDPOINTS.postChatMessage:
            await new Promise(resolve => {
                setTimeout(resolve, 2000)
            });

            return new Response(JSON.stringify(examples.searchResult.chat_session), {
                status: 200,
                headers: { "Content-Type": "application/json" }
            });
        default:
            throw new Error(`localChatFetch :: Unknown endpoint: ${endpoint}`);
    }

    return null;
}